const mediaItems = [
  {
    title: '独家实拍：某剧组拍摄现场突发冲突全程记录',
    duration: '08:24',
    views: '326.7万',
    tag: '独家',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20film%20set%20at%20night%20with%20dramatic%20lighting%2C%20crew%20members%20silhouetted%20against%20bright%20set%20lights%2C%20handheld%20camera%20aesthetic%2C%20documentary%20style%2C%20warm%20tungsten%20tones%2C%20tense%20atmosphere%2C%20grainy%20texture&width=640&height=360&seq=media-01-2026&orientation=landscape',
  },
  {
    title: '录音曝光：圈内资深大佬私下评价当红艺人',
    duration: '12:56',
    views: '258.1万',
    tag: '爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20audio%20waveform%20visualization%20in%20warm%20red%20and%20dark%20tones%2C%20mysterious%20recording%20studio%20atmosphere%2C%20vintage%20tape%20recorder%20aesthetic%2C%20dramatic%20spotlight%20on%20microphone%2C%20noir%20style%2C%20cinematic%20composition&width=640&height=360&seq=media-02-2026&orientation=landscape',
  },
  {
    title: '监控画面：知名导演深夜娱乐场所行为全记录',
    duration: '05:18',
    views: '412.3万',
    tag: '实锤',
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20nightclub%20scene%20with%20neon%20accents%20and%20dark%20shadows%2C%20security%20camera%20aesthetic%20with%20timestamp%20overlay%20feel%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20mysterious%20atmosphere%2C%20grainy%20surveillance%20footage%20style%2C%20cinematic%20noir&width=640&height=360&seq=media-03-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            视频爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            独家实拍视频，还原事件真相，每一帧都值得细品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors"></div>
                <span className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-background-50 text-[10px] font-semibold rounded whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-1 bg-foreground-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                  <i className="ri-play-fill mr-1 text-[10px]"></i>{item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                  <span><i className="ri-time-line mr-1"></i>2小时前</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}